import * as React from "react"

const H1 = ({ className, children }) => (
  <h1 className={`text-7xl lg:text-8xl font-heading ${className}`}>{children}</h1>
)

export default H1
